import React, { useState, useEffect, useContext } from "react";
import { Select, Menu as MenuDrop, Dropdown } from "antd";
import Language from "./Language";
import MyBooking from "./Modals/MyBooking";
import Menu from "./Menu/index";
import Booking from './Booking';
import useFetch from '../../commons/useFetch'
import { Link, useLocation, useHistory, useRouteMatch } from "react-router-dom";
import Login from "./Modals/Login";
import { Context } from '../../contexts/Account';
import { ContextHotel} from '../../contexts/Hotels'

function Header() {
  const { Option } = Select;
  const { data: hotels } = useFetch('https://610ec1597f793c00174195b7.mockapi.io/api/hotels')
  let history = useHistory();
  let match = useRouteMatch({ path:`/hotel/:id`});
  const pathname = window.location.pathname;
  const [loginVisible, setLoginVisible] = useState(false);
  const { loginAccount, onLogoutAccount } = useContext(Context);
  const { hotelContext, onClickId } = useContext(ContextHotel);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth)
  const userLogin = JSON.parse(localStorage.getItem("userLogin"));

  const HandleHotels = (id) => {
    history.push(`/hotel/${id}`);
  }
  const showModalLogin = () => setLoginVisible(true);
  const HandleLogout=()=>{
    onLogoutAccount();
    setLoginVisible(false);
  }
  const DropMenu = (
    <MenuDrop className="menuDropProfile">
      <MenuDrop.Item key="0">
        <Link to="/profile" className="menuItem menuProfile"><img className="img-fluid" src="/images/ic_profile.png" alt="" /><span>Tài khoản</span></Link>
      </MenuDrop.Item>
      <MenuDrop.Item key="1">
        <Link to="/profile/my-booking" className="menuItem menuMyBooking"><img className="img-fluid" src="/images/ic_room.png" alt="" /><span>Đặt phòng của tôi</span></Link>
      </MenuDrop.Item>
      <MenuDrop.Item key="3">
        <Link onClick={HandleLogout} to="/" className="menuItem menuLogout"><img className="img-fluid" src="/images/ic_leave.png" alt="" /><span>Đăng xuất</span></Link>
      </MenuDrop.Item>
    </MenuDrop>
  );
  

  const modal = () => {
    if (pathname == "/login=true") {
      setLoginVisible(true);
    } else if (pathname == "/login=false") {
      setLoginVisible(false)
    }
  }

  window.addEventListener('resize', handleResize)
  function handleResize() {
    setScreenWidth(window.innerWidth)
  }
  
  useEffect(() => {
    modal();
    if (match != null) {
      const idHotel = match.params.id;
      console.log(match.params.id)
      onClickId(idHotel)
    } else {
      onClickId(null)
    }
  }, [hotelContext])
  return (
    <header className="header">
      <div className="headerStyle">
        <div className="header_left">
          <Link to="/">
            <div className="logo">
              <img className="img-fluid" src="/images/logo.png" alt="" />
            </div>
          </Link>
          <ul className="listStyle">
            <li className="locationHeader">
              <div className="formLocation">
                <Select placeholder="Khách sạn" onChange={(id) => HandleHotels(id)} value={hotelContext}  >
                  {hotels.map((option) => (
                    <Option key={option.id}>{option.name}</Option>
                  ))}
                </Select>

              </div>
            </li>
            <li className="languageHeader">
              <Language />
            </li>
            {
              <li className="bookingPopup">
                {!loginAccount ?
                  (<MyBooking />)
                  : (<Link to="/my-booking">Đặt phòng của tôi</Link>)}

              </li>
            }
          </ul>
        </div>
        <div className="header_right">
          <ul className="listStyle">
            <li className="phone">
              <a href="tel:0962962733">
                <img
                  className="img-fluid imgIcon"
                  src="/images/phone.png"
                  alt=""
                />
                0962962733
              </a>
              
            </li>
            <li className={!loginAccount ? "login" : "isLogin"}>{
              !loginAccount ? (
                <>
                  <a onClick={showModalLogin}>{screenWidth > 767 ? "Đăng ký - đăng nhập" : <img className="img-fluid" src="/images/login.png" alt="" />}</a>
                  <Login loginVisible={loginVisible} setLoginVisible={setLoginVisible} />
                </>
              ) :
                <div className="logout">
                  <Dropdown overlay={DropMenu} trigger={['click']}>
                    <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                      <div className="user">
                        <div className="hello">Xin chào</div>
                        <div className="avatarHeader"><img src="/images/avatar.png" alt="" /></div>
                        <div className="userName">
                          {userLogin.username}
                        </div>
                      </div>
                    </a>
                  </Dropdown>
                  <div className="messNoti">
                    <img className="img-fluid" src="/images/mess.png" alt="" />
                    <span>0</span>
                  </div>
                </div>
            }

            </li>
            <li className="menuToggle">
              <Menu />
            </li>
            <Booking />
          </ul>
        </div>
      </div>
    </header>
  );
}
export default Header;
